import React from 'react';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ThankYouPage.css';

const ThankYouPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const type = searchParams.get('type');
  const message = location.state?.message;
  const revolutLink = location.state?.revolut_link;

  const isVoucher = type === 'voucher';
  const title = isVoucher ? t('thankYou.voucherTitle') : t('thankYou.bookingTitle');
  const subtitle = isVoucher ? t('thankYou.voucherSubtitle') : t('thankYou.bookingSubtitle');

  return (
    <div className="thank-you-page container">
      <div className="thank-you-card card">
        <div className="thank-you-icon" aria-hidden="true">✓</div>
        <h1 className="thank-you-title">{title}</h1>
        <p className="thank-you-subtitle">{subtitle}</p>
        {revolutLink && (
          <div className="thank-you-revolut-block">
            <p><strong>Pay by Revolut:</strong></p>
            <a href={revolutLink} target="_blank" rel="noopener noreferrer" className="btn btn-primary thank-you-revolut-btn">
              Open Revolut payment link
            </a>
          </div>
        )}
        {message && (
          <div className="thank-you-details">
            {message.split('\n').map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        )}
        <div className="thank-you-actions">
          <Link to="/" className="btn btn-primary">
            {t('thankYou.backHome')}
          </Link>
          {!isVoucher && (
            <Link to="/booking" className="btn btn-secondary">
              {t('thankYou.bookAnother')}
            </Link>
          )}
          {isVoucher && (
            <Link to="/booking" className="btn btn-secondary">
              {t('thankYou.bookWithVoucher')}
            </Link>
          )}
          <Link to="/booking/companions" className="btn btn-secondary">
            {t('thankYou.findCompanions')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
